if ("serviceWorker" in navigator) {
  var installButton = document.getElementById("install-button");
  // Check for iOS standalone mode
  if ("standalone" in navigator && navigator.standalone) {
    installButton.style.display = "none"; // Hide the install button
  } else if (window.matchMedia("(display-mode: standalone)").matches) {
    installButton.style.display = "none"; // Hide the install button
  } else {
    // Store the PWA installation prompt
    var deferredPrompt;
    window.addEventListener("beforeinstallprompt", function (event) {
      // Prevent the default prompt behavior
      event.preventDefault();

      // Store the event for later use
      deferredPrompt = event;

      installButton.style.display = "block"; // Show the install button

      installButton.addEventListener("click", function () {
        // Prompt the user to install the PWA
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        deferredPrompt.userChoice.then(function (choiceResult) {
          if (choiceResult.outcome === "accepted") {
            installButton.style.display = "none";
          } else {
            installButton.style.display = "block";
          }
        });
        // Clear the deferred prompt
        deferredPrompt = null;
      });
    });
  }
}

function isDesktop() {
  return window.matchMedia("(min-width: 992px)").matches;
}

function applySidebarState() {
  if (!isDesktop()) return;
  const saved = localStorage.getItem("ss_sidebar_expanded"); // "1" or "0"
  document.body.classList.toggle("sidebar-expanded", saved === "1");
}

function setupDesktopSidebar() {
  const btn = document.getElementById("ss-desktop-toggle");
  if (!btn) return;
  // Avoid double binding (Turbo)
  if (btn.dataset.bound === "true") return;
  btn.dataset.bound = "true";
  applySidebarState();
  btn.addEventListener("click", (e) => {
    if (!isDesktop()) return; // Mobile: let Bootstrap handle offcanvas
    e.preventDefault();
    e.stopPropagation();
    const willExpand = !document.body.classList.contains("sidebar-expanded");
    document.body.classList.toggle("sidebar-expanded", willExpand);
    localStorage.setItem("ss_sidebar_expanded", willExpand ? "1" : "0");
  });
  window.addEventListener("resize", applySidebarState);
}

// Auto hide top header
function setupTopHeaderAutoHide() {
  const header = document.querySelector(".streetsnap-topbar");
  if (!header) return;
  let lastY = window.scrollY;
  window.addEventListener("scroll", () => {
    const y = window.scrollY;
    if (y <= 0) {
      header.classList.remove("is-hidden");
      lastY = y;
      return;
    }
    if (y > lastY) header.classList.add("is-hidden");   // scrolling down
    else header.classList.remove("is-hidden");          // scrolling up
    lastY = y;
  }, { passive: true });
}

function initNavbar() {
  setupDesktopSidebar();
  setupTopHeaderAutoHide();
}

document.addEventListener("DOMContentLoaded", initNavbar);
document.addEventListener("turbo:load", initNavbar);
